// extracted by css-extract-rspack-plugin
export default {"metricLink":"OIWJZ"};